import { Link } from "react-router";
import { AuthForm } from "@/app/components/AuthForm";
import { AuthLayout } from "@/app/components/auth/AuthLayout";
import { useAuth } from "@/app/lib/auth-context";

export function SignupScreen() {
  const { signup } = useAuth();
  return (
    <AuthLayout
      headline={<>Start your <span className="text-moss">garden</span></>}
      subtitle="Create your account and organize every pot in one place."
    >
      <AuthForm
        submitLabel="Create account"
        busyLabel="Creating…"
        minPasswordLength={8}
        onSubmit={signup}
        footer={
          <>
            Already have an account?{" "}
            <Link to="/login" className="text-moss font-medium hover:underline">Sign in</Link>
          </>
        }
      />
    </AuthLayout>
  );
}
